import {
  Button,
  Form,
  Input,
  Typography,
  Modal,
  Alert,
  Row,
  Col,
} from "antd";
import React, { useState } from "react";
import { ScanOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import BarcodeScanner from "../../Comman/Scanner/BarCodeScanner";

const { Text } = Typography;

const BinOutward = ({ userData }) => {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const navigate = useNavigate();
  const [form] = Form.useForm();

  const handleTagClick = () => {
    setError("");
    setIsModalVisible(true);
  };

  const handleScan = (value) => {
    if (!value) {
      setError("No valid barcode detected. Please try again.");
      return;
    }

    setIsModalVisible(false);
    onFinish({ binId: value });
  };

  const handleScanError = (error) => {
    console.error(error);
    setError("Error accessing camera. Please check permissions.");
  };

  const onFinish = async (values) => {
    try {
      const dataToSubmit = values.binId?.trim();

      if (!dataToSubmit) {
        setError("Please provide valid Bin ID");
        return;
      }

      setError("");
      setIsLoading(true);

      navigate(`/outward/bin/confirm?binId=${encodeURIComponent(dataToSubmit)}`);
    } catch (error) {
      console.error(error);
      setIsLoading(false);
      setError("Something went wrong");
    }
  };

  return (
    <>
      <div
        style={{
          minHeight: "420px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Row gutter={[32, 32]} style={{ maxWidth: 900, width: "100%" }}>
          <Col xs={24} md={12}>
            <div
              className="dashboard-stat-card bg-card-blue"
              style={{
                minHeight: 220,
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
              }}
              onClick={handleTagClick}
            >
              <div
                className="dashboard-stat-card-inner"
                style={{
                  width: "100%",
                  textAlign: "center",
                  gap: 10,
                  justifyContent: "center",
                }}
              >
                <ScanOutlined style={{ fontSize: 28 }} />
                <div className="dashboard-stat-value">Scan Bin</div>
                <Text style={{ color: "#475569" }}>
                  Click here to open barcode scanner
                </Text>
              </div>
            </div>
          </Col>

          <Col xs={24} md={12}>
            <div
              style={{
                background: "#ffffff",
                border: "1px solid #e2e8f0",
                borderRadius: 16,
                padding: 24,
                boxShadow: "0 6px 20px rgba(15, 23, 42, 0.06)",
                height: "100%",
              }}
            >
              {error && (
                <Alert
                  message={error}
                  type="error"
                  showIcon
                  style={{ marginBottom: 16, borderRadius: 10 }}
                />
              )}

              <div style={{ textAlign: "center", marginBottom: 20 }}>
                <Text strong type="secondary">
                  Or enter Bin ID manually
                </Text>
              </div>

              <Form layout="vertical" onFinish={onFinish} form={form}>
                <Form.Item
                  name="binId"
                  label="Enter Bin ID"
                  rules={[{ required: true, message: "Bin ID is required" }]}
                >
                  <Input
                    size="large"
                    placeholder="Enter Bin ID"
                    style={{ textAlign: "center", borderRadius: 10 }}
                  />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    block
                    size="large"
                    loading={isLoading}
                    className="primary-btn"
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </div>

      <Modal
        title="Scan QR Code"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
        centered
      >
        <BarcodeScanner onScan={handleScan} onError={handleScanError} />
      </Modal>
    </>
  );
};

export default BinOutward;